/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52458.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class InboxControllerApi extends runtime.BaseAPI {
    /**
     * Get a scheduled email job and cancel it. Will fail if status of job is already cancelled, failed, or complete.
     * Cancel a scheduled email job
     */
    async cancelScheduledJobRaw(requestParameters, initOverrides) {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling cancelScheduledJob.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/scheduled-jobs/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a scheduled email job and cancel it. Will fail if status of job is already cancelled, failed, or complete.
     * Cancel a scheduled email job
     */
    async cancelScheduledJob(requestParameters, initOverrides) {
        const response = await this.cancelScheduledJobRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new inbox and with a randomized email address to send and receive from. Pass emailAddress parameter if you wish to use a specific email address. Creating an inbox is required before sending or receiving emails. If writing tests it is recommended that you create a new inbox during each test method so that it is unique and empty.
     * Create an inbox email address. An inbox has a real email address and can send and receive emails. Inboxes can be either `SMTP` or `HTTP` inboxes.
     */
    async createInboxRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        if (requestParameters.tags) {
            queryParameters['tags'] = requestParameters.tags;
        }
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.description !== undefined) {
            queryParameters['description'] = requestParameters.description;
        }
        if (requestParameters.useDomainPool !== undefined) {
            queryParameters['useDomainPool'] = requestParameters.useDomainPool;
        }
        if (requestParameters.favourite !== undefined) {
            queryParameters['favourite'] = requestParameters.favourite;
        }
        if (requestParameters.expiresAt !== undefined) {
            queryParameters['expiresAt'] = requestParameters.expiresAt;
        }
        if (requestParameters.expiresIn !== undefined) {
            queryParameters['expiresIn'] = requestParameters.expiresIn;
        }
        if (requestParameters.allowTeamAccess !== undefined) {
            queryParameters['allowTeamAccess'] = requestParameters.allowTeamAccess;
        }
        if (requestParameters.inboxType !== undefined) {
            queryParameters['inboxType'] = requestParameters.inboxType;
        }
        if (requestParameters.virtualInbox !== undefined) {
            queryParameters['virtualInbox'] = requestParameters.virtualInbox;
        }
        if (requestParameters.useShortAddress !== undefined) {
            queryParameters['useShortAddress'] = requestParameters.useShortAddress;
        }
        if (requestParameters.domainId !== undefined) {
            queryParameters['domainId'] = requestParameters.domainId;
        }
        if (requestParameters.domainName !== undefined) {
            queryParameters['domainName'] = requestParameters.domainName;
        }
        if (requestParameters.prefix !== undefined) {
            queryParameters['prefix'] = requestParameters.prefix;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new inbox and with a randomized email address to send and receive from. Pass emailAddress parameter if you wish to use a specific email address. Creating an inbox is required before sending or receiving emails. If writing tests it is recommended that you create a new inbox during each test method so that it is unique and empty.
     * Create an inbox email address. An inbox has a real email address and can send and receive emails. Inboxes can be either `SMTP` or `HTTP` inboxes.
     */
    async createInbox(requestParameters = {}, initOverrides) {
        const response = await this.createInboxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new inbox rule for forwarding, blocking, and allowing emails when sending and receiving
     * Create an inbox ruleset
     */
    async createInboxRulesetRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling createInboxRuleset.');
        }
        if (requestParameters.createInboxRulesetOptions === null || requestParameters.createInboxRulesetOptions === undefined) {
            throw new runtime.RequiredError('createInboxRulesetOptions', 'Required parameter requestParameters.createInboxRulesetOptions was null or undefined when calling createInboxRuleset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/rulesets`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createInboxRulesetOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new inbox rule for forwarding, blocking, and allowing emails when sending and receiving
     * Create an inbox ruleset
     */
    async createInboxRuleset(requestParameters, initOverrides) {
        const response = await this.createInboxRulesetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create an inbox with default options. Uses MailSlurp domain pool address and is private.
     */
    async createInboxWithDefaultsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/withDefaults`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create an inbox with default options. Uses MailSlurp domain pool address and is private.
     */
    async createInboxWithDefaults(initOverrides) {
        const response = await this.createInboxWithDefaultsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Additional endpoint that allows inbox creation with request body options. Can be more flexible that other methods for some clients.
     * Create an inbox with options. Extended options for inbox creation.
     */
    async createInboxWithOptionsRaw(requestParameters, initOverrides) {
        if (requestParameters.createInboxDto === null || requestParameters.createInboxDto === undefined) {
            throw new runtime.RequiredError('createInboxDto', 'Required parameter requestParameters.createInboxDto was null or undefined when calling createInboxWithOptions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/withOptions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createInboxDto,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Additional endpoint that allows inbox creation with request body options. Can be more flexible that other methods for some clients.
     * Create an inbox with options. Extended options for inbox creation.
     */
    async createInboxWithOptions(requestParameters, initOverrides) {
        const response = await this.createInboxWithOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Deletes all emails in an inbox. Be careful as emails cannot be recovered
     * Delete all emails in a given inboxes.
     */
    async deleteAllInboxEmailsRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling deleteAllInboxEmails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/deleteAllInboxEmails`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Deletes all emails in an inbox. Be careful as emails cannot be recovered
     * Delete all emails in a given inboxes.
     */
    async deleteAllInboxEmails(requestParameters, initOverrides) {
        await this.deleteAllInboxEmailsRaw(requestParameters, initOverrides);
    }
    /**
     * Permanently delete all inboxes and associated email addresses. This will also delete all emails within the inboxes. Be careful as inboxes cannot be recovered once deleted. Note: deleting inboxes will not impact your usage limits. Monthly inbox creation limits are based on how many inboxes were created in the last 30 days, not how many inboxes you currently have.
     * Delete all inboxes
     */
    async deleteAllInboxesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Permanently delete all inboxes and associated email addresses. This will also delete all emails within the inboxes. Be careful as inboxes cannot be recovered once deleted. Note: deleting inboxes will not impact your usage limits. Monthly inbox creation limits are based on how many inboxes were created in the last 30 days, not how many inboxes you currently have.
     * Delete all inboxes
     */
    async deleteAllInboxes(initOverrides) {
        await this.deleteAllInboxesRaw(initOverrides);
    }
    /**
     * Permanently delete all inboxes by description
     * Delete inboxes by description
     */
    async deleteAllInboxesByDescriptionRaw(requestParameters, initOverrides) {
        if (requestParameters.description === null || requestParameters.description === undefined) {
            throw new runtime.RequiredError('description', 'Required parameter requestParameters.description was null or undefined when calling deleteAllInboxesByDescription.');
        }
        const queryParameters = {};
        if (requestParameters.description !== undefined) {
            queryParameters['description'] = requestParameters.description;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/by-description`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Permanently delete all inboxes by description
     * Delete inboxes by description
     */
    async deleteAllInboxesByDescription(requestParameters, initOverrides) {
        await this.deleteAllInboxesByDescriptionRaw(requestParameters, initOverrides);
    }
    /**
     * Permanently delete all inboxes by name
     * Delete inboxes by name
     */
    async deleteAllInboxesByNameRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAllInboxesByName.');
        }
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/by-name`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Permanently delete all inboxes by name
     * Delete inboxes by name
     */
    async deleteAllInboxesByName(requestParameters, initOverrides) {
        await this.deleteAllInboxesByNameRaw(requestParameters, initOverrides);
    }
    /**
     * Permanently delete all inboxes by tag
     * Delete inboxes by tag
     */
    async deleteAllInboxesByTagRaw(requestParameters, initOverrides) {
        if (requestParameters.tag === null || requestParameters.tag === undefined) {
            throw new runtime.RequiredError('tag', 'Required parameter requestParameters.tag was null or undefined when calling deleteAllInboxesByTag.');
        }
        const queryParameters = {};
        if (requestParameters.tag !== undefined) {
            queryParameters['tag'] = requestParameters.tag;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/by-tag`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Permanently delete all inboxes by tag
     * Delete inboxes by tag
     */
    async deleteAllInboxesByTag(requestParameters, initOverrides) {
        await this.deleteAllInboxesByTagRaw(requestParameters, initOverrides);
    }
    /**
     * Permanently delete an inbox and associated email address as well as all emails within the given inbox. This action cannot be undone. Note: deleting an inbox will not affect your account usage. Monthly inbox usage is based on how many inboxes you create within 30 days, not how many exist at time of request.
     * Delete inbox
     */
    async deleteInboxRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling deleteInbox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Permanently delete an inbox and associated email address as well as all emails within the given inbox. This action cannot be undone. Note: deleting an inbox will not affect your account usage. Monthly inbox usage is based on how many inboxes you create within 30 days, not how many exist at time of request.
     * Delete inbox
     */
    async deleteInbox(requestParameters, initOverrides) {
        await this.deleteInboxRaw(requestParameters, initOverrides);
    }
    /**
     * Check if inboxes exist by email address. Useful if you are sending emails to mailslurp addresses
     * Does inbox exist
     */
    async doesInboxExistRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling doesInboxExist.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        if (requestParameters.allowCatchAll !== undefined) {
            queryParameters['allowCatchAll'] = requestParameters.allowCatchAll;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/exists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Check if inboxes exist by email address. Useful if you are sending emails to mailslurp addresses
     * Does inbox exist
     */
    async doesInboxExist(requestParameters, initOverrides) {
        const response = await this.doesInboxExistRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove any expired inboxes for your account (instead of waiting for scheduled removal on server)
     * Remove expired inboxes
     */
    async flushExpiredRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/expired`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Remove any expired inboxes for your account (instead of waiting for scheduled removal on server)
     * Remove expired inboxes
     */
    async flushExpired(requestParameters = {}, initOverrides) {
        const response = await this.flushExpiredRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List inboxes in paginated form. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time). You Can also filter by whether an inbox is favorited or use email address pattern. This method is the recommended way to query inboxes. The alternative `getInboxes` method returns a full list of inboxes but is limited to 100 results.
     * List All Inboxes Paginated
     */
    async getAllInboxesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.favourite !== undefined) {
            queryParameters['favourite'] = requestParameters.favourite;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        if (requestParameters.tag !== undefined) {
            queryParameters['tag'] = requestParameters.tag;
        }
        if (requestParameters.teamAccess !== undefined) {
            queryParameters['teamAccess'] = requestParameters.teamAccess;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.inboxType !== undefined) {
            queryParameters['inboxType'] = requestParameters.inboxType;
        }
        if (requestParameters.inboxFunction !== undefined) {
            queryParameters['inboxFunction'] = requestParameters.inboxFunction;
        }
        if (requestParameters.domainId !== undefined) {
            queryParameters['domainId'] = requestParameters.domainId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/paginated`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List inboxes in paginated form. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time). You Can also filter by whether an inbox is favorited or use email address pattern. This method is the recommended way to query inboxes. The alternative `getInboxes` method returns a full list of inboxes but is limited to 100 results.
     * List All Inboxes Paginated
     */
    async getAllInboxes(requestParameters = {}, initOverrides) {
        const response = await this.getAllInboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List inboxes in paginated form. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time). You Can also filter by whether an inbox is favorited or use email address pattern. This method is the recommended way to query inboxes. The alternative `getInboxes` method returns a full list of inboxes but is limited to 100 results.
     * List All Inboxes Offset Paginated
     */
    async getAllInboxesOffsetPaginatedRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.favourite !== undefined) {
            queryParameters['favourite'] = requestParameters.favourite;
        }
        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }
        if (requestParameters.tag !== undefined) {
            queryParameters['tag'] = requestParameters.tag;
        }
        if (requestParameters.teamAccess !== undefined) {
            queryParameters['teamAccess'] = requestParameters.teamAccess;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.inboxType !== undefined) {
            queryParameters['inboxType'] = requestParameters.inboxType;
        }
        if (requestParameters.inboxFunction !== undefined) {
            queryParameters['inboxFunction'] = requestParameters.inboxFunction;
        }
        if (requestParameters.domainId !== undefined) {
            queryParameters['domainId'] = requestParameters.domainId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/offset-paginated`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List inboxes in paginated form. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time). You Can also filter by whether an inbox is favorited or use email address pattern. This method is the recommended way to query inboxes. The alternative `getInboxes` method returns a full list of inboxes but is limited to 100 results.
     * List All Inboxes Offset Paginated
     */
    async getAllInboxesOffsetPaginated(requestParameters = {}, initOverrides) {
        const response = await this.getAllInboxesOffsetPaginatedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns paginated list of all plus alias addresses found for in account based on received emails that used the inbox address with a +xyz alias.
     * Get all sub address plus address aliases for an inbox
     */
    async getAllPlusAddressesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/plus-addresses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns paginated list of all plus alias addresses found for in account based on received emails that used the inbox address with a +xyz alias.
     * Get all sub address plus address aliases for an inbox
     */
    async getAllPlusAddresses(requestParameters = {}, initOverrides) {
        const response = await this.getAllPlusAddressesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Schedule sending of emails using scheduled jobs. These can be inbox or account level.
     * Get all scheduled email sending jobs for account
     */
    async getAllScheduledJobsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/scheduled-jobs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Schedule sending of emails using scheduled jobs. These can be inbox or account level.
     * Get all scheduled email sending jobs for account
     */
    async getAllScheduledJobs(requestParameters = {}, initOverrides) {
        const response = await this.getAllScheduledJobsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all email delivery statuses for an inbox
     */
    async getDeliveryStatusesByInboxIdRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getDeliveryStatusesByInboxId.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/delivery-status`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get all email delivery statuses for an inbox
     */
    async getDeliveryStatusesByInboxId(requestParameters, initOverrides) {
        const response = await this.getDeliveryStatusesByInboxIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List emails that an inbox has received. Only emails that are sent to the inbox\'s email address will appear in the inbox. It may take several seconds for any email you send to an inbox\'s email address to appear in the inbox. To make this endpoint wait for a minimum number of emails use the `minCount` parameter. The server will retry the inbox database until the `minCount` is satisfied or the `retryTimeout` is reached
     * Get emails in an Inbox. This method is not idempotent as it allows retries and waits if you want certain conditions to be met before returning. For simple listing and sorting of known emails use the email controller instead.
     */
    async getEmailsRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getEmails.');
        }
        const queryParameters = {};
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.retryTimeout !== undefined) {
            queryParameters['retryTimeout'] = requestParameters.retryTimeout;
        }
        if (requestParameters.delayTimeout !== undefined) {
            queryParameters['delayTimeout'] = requestParameters.delayTimeout;
        }
        if (requestParameters.minCount !== undefined) {
            queryParameters['minCount'] = requestParameters.minCount;
        }
        if (requestParameters.unreadOnly !== undefined) {
            queryParameters['unreadOnly'] = requestParameters.unreadOnly;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/emails`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List emails that an inbox has received. Only emails that are sent to the inbox\'s email address will appear in the inbox. It may take several seconds for any email you send to an inbox\'s email address to appear in the inbox. To make this endpoint wait for a minimum number of emails use the `minCount` parameter. The server will retry the inbox database until the `minCount` is satisfied or the `retryTimeout` is reached
     * Get emails in an Inbox. This method is not idempotent as it allows retries and waits if you want certain conditions to be met before returning. For simple listing and sorting of known emails use the email controller instead.
     */
    async getEmails(requestParameters, initOverrides) {
        const response = await this.getEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get IMAP access usernames and passwords
     */
    async getImapAccessRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/imap-access`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get IMAP access usernames and passwords
     */
    async getImapAccess(requestParameters = {}, initOverrides) {
        const response = await this.getImapAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get IMAP and SMTP access usernames and passwords
     */
    async getImapSmtpAccessRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/imap-smtp-access`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get IMAP and SMTP access usernames and passwords
     */
    async getImapSmtpAccess(requestParameters = {}, initOverrides) {
        const response = await this.getImapSmtpAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get IMAP and SMTP access details in .env format
     */
    async getImapSmtpAccessEnvRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/imap-smtp-access/env`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get IMAP and SMTP access details in .env format
     */
    async getImapSmtpAccessEnv(requestParameters = {}, initOverrides) {
        const response = await this.getImapSmtpAccessEnvRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get IMAP and SMTP server hosts
     */
    async getImapSmtpAccessServersRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/imap-smtp-access/servers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get IMAP and SMTP server hosts
     */
    async getImapSmtpAccessServers(initOverrides) {
        const response = await this.getImapSmtpAccessServersRaw(initOverrides);
        return await response.value();
    }
    /**
     * Returns an inbox\'s properties, including its email address and ID.
     * Get Inbox. Returns properties of an inbox.
     */
    async getInboxRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInbox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns an inbox\'s properties, including its email address and ID.
     * Get Inbox. Returns properties of an inbox.
     */
    async getInbox(requestParameters, initOverrides) {
        const response = await this.getInboxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a inbox result by email address
     * Search for an inbox with the provided email address
     */
    async getInboxByEmailAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling getInboxByEmailAddress.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/byEmailAddress`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a inbox result by email address
     * Search for an inbox with the provided email address
     */
    async getInboxByEmailAddress(requestParameters, initOverrides) {
        const response = await this.getInboxByEmailAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a inbox result by name
     * Search for an inbox with the given name
     */
    async getInboxByNameRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getInboxByName.');
        }
        const queryParameters = {};
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/byName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a inbox result by name
     * Search for an inbox with the given name
     */
    async getInboxByName(requestParameters, initOverrides) {
        const response = await this.getInboxByNameRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get total inbox count
     */
    async getInboxCountRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get total inbox count
     */
    async getInboxCount(initOverrides) {
        const response = await this.getInboxCountRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get email count in inbox
     */
    async getInboxEmailCountRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxEmailCount.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/emails/count`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get email count in inbox
     */
    async getInboxEmailCount(requestParameters, initOverrides) {
        const response = await this.getInboxEmailCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of emails in an inbox. Does not hold connections open.
     * Get inbox emails paginated
     */
    async getInboxEmailsPaginatedRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxEmailsPaginated.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.syncConnectors !== undefined) {
            queryParameters['syncConnectors'] = requestParameters.syncConnectors;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/emails/paginated`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of emails in an inbox. Does not hold connections open.
     * Get inbox emails paginated
     */
    async getInboxEmailsPaginated(requestParameters, initOverrides) {
        const response = await this.getInboxEmailsPaginatedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get list of inbox IDs
     * Get all inbox IDs
     */
    async getInboxIdsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get list of inbox IDs
     * Get all inbox IDs
     */
    async getInboxIds(initOverrides) {
        const response = await this.getInboxIdsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Returns a plus address object based on emails that used the inbox address with a +xyz alias.
     * Get sub address plus address for an inbox
     */
    async getInboxPlusAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.plusAddressId === null || requestParameters.plusAddressId === undefined) {
            throw new runtime.RequiredError('plusAddressId', 'Required parameter requestParameters.plusAddressId was null or undefined when calling getInboxPlusAddress.');
        }
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxPlusAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/plus-addresses/{plusAddressId}`.replace(`{${"plusAddressId"}}`, encodeURIComponent(String(requestParameters.plusAddressId))).replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns a plus address object based on emails that used the inbox address with a +xyz alias.
     * Get sub address plus address for an inbox
     */
    async getInboxPlusAddress(requestParameters, initOverrides) {
        const response = await this.getInboxPlusAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns a plus address object based on emails that used the inbox address with a +xyz alias.
     * Get sub address plus address by ID
     */
    async getInboxPlusAddressByIdRaw(requestParameters, initOverrides) {
        if (requestParameters.plusAddressId === null || requestParameters.plusAddressId === undefined) {
            throw new runtime.RequiredError('plusAddressId', 'Required parameter requestParameters.plusAddressId was null or undefined when calling getInboxPlusAddressById.');
        }
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/plus-addresses/{plusAddressId}`.replace(`{${"plusAddressId"}}`, encodeURIComponent(String(requestParameters.plusAddressId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns a plus address object based on emails that used the inbox address with a +xyz alias.
     * Get sub address plus address by ID
     */
    async getInboxPlusAddressById(requestParameters, initOverrides) {
        const response = await this.getInboxPlusAddressByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns paginated list of all emails for a given plus alias addresses found for an inbox based on received emails that used the inbox address with a +xyz alias.
     * Get emails for a given inbox plus address
     */
    async getInboxPlusAddressEmailsRaw(requestParameters, initOverrides) {
        if (requestParameters.plusAddress === null || requestParameters.plusAddress === undefined) {
            throw new runtime.RequiredError('plusAddress', 'Required parameter requestParameters.plusAddress was null or undefined when calling getInboxPlusAddressEmails.');
        }
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxPlusAddressEmails.');
        }
        const queryParameters = {};
        if (requestParameters.plusAddress !== undefined) {
            queryParameters['plusAddress'] = requestParameters.plusAddress;
        }
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/plus-addresses/emails`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns paginated list of all emails for a given plus alias addresses found for an inbox based on received emails that used the inbox address with a +xyz alias.
     * Get emails for a given inbox plus address
     */
    async getInboxPlusAddressEmails(requestParameters, initOverrides) {
        const response = await this.getInboxPlusAddressEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns paginated list of all emails for a given plus alias addresses found for an inbox based on received emails that used the inbox address with a +xyz alias.
     * Get emails for a given inbox plus address
     */
    async getInboxPlusAddressEmailsForPlusAddressIdRaw(requestParameters, initOverrides) {
        if (requestParameters.plusAddressId === null || requestParameters.plusAddressId === undefined) {
            throw new runtime.RequiredError('plusAddressId', 'Required parameter requestParameters.plusAddressId was null or undefined when calling getInboxPlusAddressEmailsForPlusAddressId.');
        }
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxPlusAddressEmailsForPlusAddressId.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/plus-addresses/{plusAddressId}/emails`.replace(`{${"plusAddressId"}}`, encodeURIComponent(String(requestParameters.plusAddressId))).replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns paginated list of all emails for a given plus alias addresses found for an inbox based on received emails that used the inbox address with a +xyz alias.
     * Get emails for a given inbox plus address
     */
    async getInboxPlusAddressEmailsForPlusAddressId(requestParameters, initOverrides) {
        const response = await this.getInboxPlusAddressEmailsForPlusAddressIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns paginated list of all plus alias addresses found for an inbox based on received emails that used the inbox address with a +xyz alias.
     * Get sub address plus address aliases for an inbox
     */
    async getInboxPlusAddressesRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxPlusAddresses.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/plus-addresses`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns paginated list of all plus alias addresses found for an inbox based on received emails that used the inbox address with a +xyz alias.
     * Get sub address plus address aliases for an inbox
     */
    async getInboxPlusAddresses(requestParameters, initOverrides) {
        const response = await this.getInboxPlusAddressesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get sent email count in inbox
     */
    async getInboxSentCountRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxSentCount.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/sent/count`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get sent email count in inbox
     */
    async getInboxSentCount(requestParameters, initOverrides) {
        const response = await this.getInboxSentCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns an inbox\'s sent email receipts. Call individual sent email endpoints for more details. Note for privacy reasons the full body of sent emails is never stored. An MD5 hash hex is available for comparison instead.
     * Get Inbox Sent Emails
     */
    async getInboxSentEmailsRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getInboxSentEmails.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/sent`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns an inbox\'s sent email receipts. Call individual sent email endpoints for more details. Note for privacy reasons the full body of sent emails is never stored. An MD5 hash hex is available for comparison instead.
     * Get Inbox Sent Emails
     */
    async getInboxSentEmails(requestParameters, initOverrides) {
        const response = await this.getInboxSentEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all inbox tags
     * Get inbox tags
     */
    async getInboxTagsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get all inbox tags
     * Get inbox tags
     */
    async getInboxTags(requestParameters = {}, initOverrides) {
        const response = await this.getInboxTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all inbox tags paginated
     * Get inbox tags paginated
     */
    async getInboxTagsPaginatedRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/tags/paginated`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get all inbox tags paginated
     * Get inbox tags paginated
     */
    async getInboxTagsPaginated(requestParameters = {}, initOverrides) {
        const response = await this.getInboxTagsPaginatedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List the inboxes you have created. Note use of the more advanced `getAllInboxes` is recommended and allows paginated access using a limit and sort parameter.
     * List Inboxes and email addresses
     */
    async getInboxesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.excludeCatchAllInboxes !== undefined) {
            queryParameters['excludeCatchAllInboxes'] = requestParameters.excludeCatchAllInboxes;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List the inboxes you have created. Note use of the more advanced `getAllInboxes` is recommended and allows paginated access using a limit and sort parameter.
     * List Inboxes and email addresses
     */
    async getInboxes(requestParameters = {}, initOverrides) {
        const response = await this.getInboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all inboxes for a given inbox tag
     * Get inboxes for a tag
     */
    async getInboxesByTagRaw(requestParameters, initOverrides) {
        if (requestParameters.tag === null || requestParameters.tag === undefined) {
            throw new runtime.RequiredError('tag', 'Required parameter requestParameters.tag was null or undefined when calling getInboxesByTag.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.tag !== undefined) {
            queryParameters['tag'] = requestParameters.tag;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/tags/inboxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get all inboxes for a given inbox tag
     * Get inboxes for a tag
     */
    async getInboxesByTag(requestParameters, initOverrides) {
        const response = await this.getInboxesByTagRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the newest email in an inbox or wait for one to arrive
     * Get latest email in an inbox. Use `WaitForController` to get emails that may not have arrived yet.
     */
    async getLatestEmailInInboxRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getLatestEmailInInbox.');
        }
        if (requestParameters.timeoutMillis === null || requestParameters.timeoutMillis === undefined) {
            throw new runtime.RequiredError('timeoutMillis', 'Required parameter requestParameters.timeoutMillis was null or undefined when calling getLatestEmailInInbox.');
        }
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        if (requestParameters.timeoutMillis !== undefined) {
            queryParameters['timeoutMillis'] = requestParameters.timeoutMillis;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/getLatestEmail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get the newest email in an inbox or wait for one to arrive
     * Get latest email in an inbox. Use `WaitForController` to get emails that may not have arrived yet.
     */
    async getLatestEmailInInbox(requestParameters, initOverrides) {
        const response = await this.getLatestEmailInInboxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List organization inboxes in paginated form. These are inboxes created with `allowTeamAccess` flag enabled. Organization inboxes are `readOnly` for non-admin users. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time).
     * List Organization Inboxes Paginated
     */
    async getOrganizationInboxesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/organization`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List organization inboxes in paginated form. These are inboxes created with `allowTeamAccess` flag enabled. Organization inboxes are `readOnly` for non-admin users. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time).
     * List Organization Inboxes Paginated
     */
    async getOrganizationInboxes(requestParameters = {}, initOverrides) {
        const response = await this.getOrganizationInboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List inboxes that have sent emails
     * List all inboxes with sent emails
     */
    async getOutboxesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/outboxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List inboxes that have sent emails
     * List all inboxes with sent emails
     */
    async getOutboxes(requestParameters = {}, initOverrides) {
        const response = await this.getOutboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a scheduled email job details.
     * Get a scheduled email job
     */
    async getScheduledJobRaw(requestParameters, initOverrides) {
        if (requestParameters.jobId === null || requestParameters.jobId === undefined) {
            throw new runtime.RequiredError('jobId', 'Required parameter requestParameters.jobId was null or undefined when calling getScheduledJob.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/scheduled-jobs/{jobId}`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a scheduled email job details.
     * Get a scheduled email job
     */
    async getScheduledJob(requestParameters, initOverrides) {
        const response = await this.getScheduledJobRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Schedule sending of emails using scheduled jobs.
     * Get all scheduled email sending jobs for the inbox
     */
    async getScheduledJobsByInboxIdRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling getScheduledJobsByInboxId.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/scheduled-jobs`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Schedule sending of emails using scheduled jobs.
     * Get all scheduled email sending jobs for the inbox
     */
    async getScheduledJobsByInboxId(requestParameters, initOverrides) {
        const response = await this.getScheduledJobsByInboxIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get SMTP access usernames and passwords
     */
    async getSmtpAccessRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/smtp-access`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get SMTP access usernames and passwords
     */
    async getSmtpAccess(requestParameters = {}, initOverrides) {
        const response = await this.getSmtpAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns whether an email address is available
     * Is email address available
     */
    async isEmailAddressAvailableRaw(requestParameters, initOverrides) {
        if (requestParameters.emailAddress === null || requestParameters.emailAddress === undefined) {
            throw new runtime.RequiredError('emailAddress', 'Required parameter requestParameters.emailAddress was null or undefined when calling isEmailAddressAvailable.');
        }
        const queryParameters = {};
        if (requestParameters.emailAddress !== undefined) {
            queryParameters['emailAddress'] = requestParameters.emailAddress;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/available`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Returns whether an email address is available
     * Is email address available
     */
    async isEmailAddressAvailable(requestParameters, initOverrides) {
        const response = await this.isEmailAddressAvailableRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List all rulesets attached to an inbox
     * List inbox rulesets
     */
    async listInboxRulesetsRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling listInboxRulesets.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/rulesets`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List all rulesets attached to an inbox
     * List inbox rulesets
     */
    async listInboxRulesets(requestParameters, initOverrides) {
        const response = await this.listInboxRulesetsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List all tracking pixels sent from an inbox
     * List inbox tracking pixels
     */
    async listInboxTrackingPixelsRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling listInboxTrackingPixels.');
        }
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/tracking-pixels`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List all tracking pixels sent from an inbox
     * List inbox tracking pixels
     */
    async listInboxTrackingPixels(requestParameters, initOverrides) {
        const response = await this.listInboxTrackingPixelsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Search inboxes and return in paginated form. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time). You Can also filter by whether an inbox is favorited or use email address pattern. This method is the recommended way to query inboxes. The alternative `getInboxes` method returns a full list of inboxes but is limited to 100 results.
     * Search all inboxes and return matching inboxes
     */
    async searchInboxesRaw(requestParameters, initOverrides) {
        if (requestParameters.searchInboxesOptions === null || requestParameters.searchInboxesOptions === undefined) {
            throw new runtime.RequiredError('searchInboxesOptions', 'Required parameter requestParameters.searchInboxesOptions was null or undefined when calling searchInboxes.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchInboxesOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Search inboxes and return in paginated form. The results are available on the `content` property of the returned object. This method allows for page index (zero based), page size (how many results to return), and a sort direction (based on createdAt time). You Can also filter by whether an inbox is favorited or use email address pattern. This method is the recommended way to query inboxes. The alternative `getInboxes` method returns a full list of inboxes but is limited to 100 results.
     * Search all inboxes and return matching inboxes
     */
    async searchInboxes(requestParameters, initOverrides) {
        const response = await this.searchInboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send an email from an inbox\'s email address.  The request body should contain the `SendEmailOptions` that include recipients, attachments, body etc. See `SendEmailOptions` for all available properties. Note the `inboxId` refers to the inbox\'s id not the inbox\'s email address. See https://www.mailslurp.com/guides/ for more information on how to send emails. This method does not return a sent email entity due to legacy reasons. To send and get a sent email as returned response use the sister method `sendEmailAndConfirm`.
     * Send Email
     */
    async sendEmailRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling sendEmail.');
        }
        if (requestParameters.sendEmailOptions === null || requestParameters.sendEmailOptions === undefined) {
            throw new runtime.RequiredError('sendEmailOptions', 'Required parameter requestParameters.sendEmailOptions was null or undefined when calling sendEmail.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendEmailOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send an email from an inbox\'s email address.  The request body should contain the `SendEmailOptions` that include recipients, attachments, body etc. See `SendEmailOptions` for all available properties. Note the `inboxId` refers to the inbox\'s id not the inbox\'s email address. See https://www.mailslurp.com/guides/ for more information on how to send emails. This method does not return a sent email entity due to legacy reasons. To send and get a sent email as returned response use the sister method `sendEmailAndConfirm`.
     * Send Email
     */
    async sendEmail(requestParameters, initOverrides) {
        await this.sendEmailRaw(requestParameters, initOverrides);
    }
    /**
     * Sister method for standard `sendEmail` method with the benefit of returning a `SentEmail` entity confirming the successful sending of the email with a link to the sent object created for it.
     * Send email and return sent confirmation
     */
    async sendEmailAndConfirmRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling sendEmailAndConfirm.');
        }
        if (requestParameters.sendEmailOptions === null || requestParameters.sendEmailOptions === undefined) {
            throw new runtime.RequiredError('sendEmailOptions', 'Required parameter requestParameters.sendEmailOptions was null or undefined when calling sendEmailAndConfirm.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/confirm`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendEmailOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Sister method for standard `sendEmail` method with the benefit of returning a `SentEmail` entity confirming the successful sending of the email with a link to the sent object created for it.
     * Send email and return sent confirmation
     */
    async sendEmailAndConfirm(requestParameters, initOverrides) {
        const response = await this.sendEmailAndConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send an email using a queue. Will place the email onto a queue that will then be processed and sent. Use this queue method to enable any failed email sending to be recovered. This will prevent lost emails when sending if your account encounters a block or payment issue.
     * Send email with queue
     */
    async sendEmailWithQueueRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling sendEmailWithQueue.');
        }
        if (requestParameters.validateBeforeEnqueue === null || requestParameters.validateBeforeEnqueue === undefined) {
            throw new runtime.RequiredError('validateBeforeEnqueue', 'Required parameter requestParameters.validateBeforeEnqueue was null or undefined when calling sendEmailWithQueue.');
        }
        if (requestParameters.sendEmailOptions === null || requestParameters.sendEmailOptions === undefined) {
            throw new runtime.RequiredError('sendEmailOptions', 'Required parameter requestParameters.sendEmailOptions was null or undefined when calling sendEmailWithQueue.');
        }
        const queryParameters = {};
        if (requestParameters.validateBeforeEnqueue !== undefined) {
            queryParameters['validateBeforeEnqueue'] = requestParameters.validateBeforeEnqueue;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/with-queue`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendEmailOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send an email using a queue. Will place the email onto a queue that will then be processed and sent. Use this queue method to enable any failed email sending to be recovered. This will prevent lost emails when sending if your account encounters a block or payment issue.
     * Send email with queue
     */
    async sendEmailWithQueue(requestParameters, initOverrides) {
        await this.sendEmailWithQueueRaw(requestParameters, initOverrides);
    }
    /**
     * Send email using an SMTP envelope containing RCPT TO, MAIL FROM, and a SMTP BODY.
     * Send email using an SMTP mail envelope and message body and return sent confirmation
     */
    async sendSmtpEnvelopeRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling sendSmtpEnvelope.');
        }
        if (requestParameters.sendSMTPEnvelopeOptions === null || requestParameters.sendSMTPEnvelopeOptions === undefined) {
            throw new runtime.RequiredError('sendSMTPEnvelopeOptions', 'Required parameter requestParameters.sendSMTPEnvelopeOptions was null or undefined when calling sendSmtpEnvelope.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/smtp-envelope`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendSMTPEnvelopeOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Send email using an SMTP envelope containing RCPT TO, MAIL FROM, and a SMTP BODY.
     * Send email using an SMTP mail envelope and message body and return sent confirmation
     */
    async sendSmtpEnvelope(requestParameters, initOverrides) {
        const response = await this.sendSmtpEnvelopeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Send an inbox a test email to test email receiving is working
     * Send a test email to inbox
     */
    async sendTestEmailRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling sendTestEmail.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/send-test-email`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Send an inbox a test email to test email receiving is working
     * Send a test email to inbox
     */
    async sendTestEmail(requestParameters, initOverrides) {
        await this.sendTestEmailRaw(requestParameters, initOverrides);
    }
    /**
     * Send an email using a delay. Will place the email onto a scheduler that will then be processed and sent. Use delays to schedule email sending.
     * Send email with with delay or schedule
     */
    async sendWithScheduleRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling sendWithSchedule.');
        }
        if (requestParameters.sendEmailOptions === null || requestParameters.sendEmailOptions === undefined) {
            throw new runtime.RequiredError('sendEmailOptions', 'Required parameter requestParameters.sendEmailOptions was null or undefined when calling sendWithSchedule.');
        }
        const queryParameters = {};
        if (requestParameters.sendAtTimestamp !== undefined) {
            queryParameters['sendAtTimestamp'] = requestParameters.sendAtTimestamp;
        }
        if (requestParameters.sendAtNowPlusSeconds !== undefined) {
            queryParameters['sendAtNowPlusSeconds'] = requestParameters.sendAtNowPlusSeconds;
        }
        if (requestParameters.validateBeforeEnqueue !== undefined) {
            queryParameters['validateBeforeEnqueue'] = requestParameters.validateBeforeEnqueue;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/with-schedule`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendEmailOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Send an email using a delay. Will place the email onto a scheduler that will then be processed and sent. Use delays to schedule email sending.
     * Send email with with delay or schedule
     */
    async sendWithSchedule(requestParameters, initOverrides) {
        const response = await this.sendWithScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Set and return new favorite state for an inbox
     * Set inbox favourited state
     */
    async setInboxFavouritedRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling setInboxFavourited.');
        }
        if (requestParameters.setInboxFavouritedOptions === null || requestParameters.setInboxFavouritedOptions === undefined) {
            throw new runtime.RequiredError('setInboxFavouritedOptions', 'Required parameter requestParameters.setInboxFavouritedOptions was null or undefined when calling setInboxFavourited.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}/favourite`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setInboxFavouritedOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Set and return new favorite state for an inbox
     * Set inbox favourited state
     */
    async setInboxFavourited(requestParameters, initOverrides) {
        const response = await this.setInboxFavouritedRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update IMAP access usernames and passwords
     */
    async updateImapAccessRaw(requestParameters, initOverrides) {
        if (requestParameters.updateImapAccessOptions === null || requestParameters.updateImapAccessOptions === undefined) {
            throw new runtime.RequiredError('updateImapAccessOptions', 'Required parameter requestParameters.updateImapAccessOptions was null or undefined when calling updateImapAccess.');
        }
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/imap-access`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateImapAccessOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update IMAP access usernames and passwords
     */
    async updateImapAccess(requestParameters, initOverrides) {
        await this.updateImapAccessRaw(requestParameters, initOverrides);
    }
    /**
     * Update editable fields on an inbox
     * Update Inbox. Change name and description. Email address is not editable.
     */
    async updateInboxRaw(requestParameters, initOverrides) {
        if (requestParameters.inboxId === null || requestParameters.inboxId === undefined) {
            throw new runtime.RequiredError('inboxId', 'Required parameter requestParameters.inboxId was null or undefined when calling updateInbox.');
        }
        if (requestParameters.updateInboxOptions === null || requestParameters.updateInboxOptions === undefined) {
            throw new runtime.RequiredError('updateInboxOptions', 'Required parameter requestParameters.updateInboxOptions was null or undefined when calling updateInbox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/{inboxId}`.replace(`{${"inboxId"}}`, encodeURIComponent(String(requestParameters.inboxId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateInboxOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update editable fields on an inbox
     * Update Inbox. Change name and description. Email address is not editable.
     */
    async updateInbox(requestParameters, initOverrides) {
        const response = await this.updateInboxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update SMTP access usernames and passwords
     */
    async updateSmtpAccessRaw(requestParameters, initOverrides) {
        if (requestParameters.updateSmtpAccessOptions === null || requestParameters.updateSmtpAccessOptions === undefined) {
            throw new runtime.RequiredError('updateSmtpAccessOptions', 'Required parameter requestParameters.updateSmtpAccessOptions was null or undefined when calling updateSmtpAccess.');
        }
        const queryParameters = {};
        if (requestParameters.inboxId !== undefined) {
            queryParameters['inboxId'] = requestParameters.inboxId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/inboxes/smtp-access`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateSmtpAccessOptions,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update SMTP access usernames and passwords
     */
    async updateSmtpAccess(requestParameters, initOverrides) {
        await this.updateSmtpAccessRaw(requestParameters, initOverrides);
    }
}
/**
 * @export
 */
export const CreateInboxInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const GetAllInboxesSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetAllInboxesInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const GetAllInboxesInboxFunctionEnum = {
    ALIAS: 'ALIAS',
    THREAD: 'THREAD',
    CATCH_ALL: 'CATCH_ALL',
    CONNECTOR: 'CONNECTOR',
    ACCOUNT: 'ACCOUNT',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const GetAllInboxesOffsetPaginatedSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetAllInboxesOffsetPaginatedInboxTypeEnum = {
    HTTP_INBOX: 'HTTP_INBOX',
    SMTP_INBOX: 'SMTP_INBOX'
};
/**
 * @export
 */
export const GetAllInboxesOffsetPaginatedInboxFunctionEnum = {
    ALIAS: 'ALIAS',
    THREAD: 'THREAD',
    CATCH_ALL: 'CATCH_ALL',
    CONNECTOR: 'CONNECTOR',
    ACCOUNT: 'ACCOUNT',
    GUEST: 'GUEST'
};
/**
 * @export
 */
export const GetAllPlusAddressesSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetAllScheduledJobsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetDeliveryStatusesByInboxIdSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetEmailsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxEmailsPaginatedSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxPlusAddressEmailsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxPlusAddressEmailsForPlusAddressIdSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxPlusAddressesSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxSentEmailsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxTagsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxTagsPaginatedSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxesSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetInboxesByTagSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetOrganizationInboxesSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetOutboxesSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const GetScheduledJobsByInboxIdSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const ListInboxRulesetsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const ListInboxTrackingPixelsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
